const ferries = {
  ferry: "Πορθμείο", // translated
  ferries: "Πλοία", // translated
  selectOriginPort: "Επιλέξτε τη θύρα προέλευσης", // translated
  selectDestPort: "Επιλέξτε τη θύρα προορισμού", // translated
  continue: "Να συνεχίσει", // translated
  viewTimetables: "Προβολή ωραρίων", // translated
  operator: "Χειριστής", // translated
  cabin: "Καμπίνα", // translated
  cabins: "Καμπίνες", // translated
  place: "Θέση", // translated
  places: "Μέρη", // translated
  seat: "Εδρα", // translated
  seats: "Καθίσματα", // translated
  seating: "Καθίσματα", // translated
  deckSpace: "Χώρος στο κατάστρωμα", // translated
  compulsory: "υποχρεωτικός", // translated
  departure: "Αναχώρηση", // translated
  total: "Σύνολο", // translated
  back: "Πίσω", // translated
  next: "Επόμενο", // translated
  duration: "Διάρκεια", // translated
  return: "ΕΠΙΣΤΡΟΦΗ", // translated
  prebook: "Προβιβλίο", // translated
  travelInfo: "Ταξιδιωτικές Πληροφορίες", // translated
  book: "Βιβλίο", // translated
  adults: "Ενήλικες", // translated
  child: "Παιδί", // translated
  seniors: "Ηλικιωμένοι", // translated
  senior: "Αρχαιότερος", // translated
  to: "προς την", // translated
  passenger: "Επιβάτης", // translated
  details: "Λεπτομέριες", // translated
  currencyForTickets: "Το νόμισμα για αυτά τα εισιτήρια θα είναι", // translated
  seatsError: "Ο αριθμός των επιβατών δεν είναι ίσος με τη χωρητικότητα.", // translated
  title: "Τίτλος", // translated
  firstName: "Ονομα", // translated
  lastName: "Επίθετο", // translated
  email: "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ", // translated
  phone: "Τηλέφωνο", // translated
  dateOfBirth: "Ημερομηνια γεννησης", // translated
  placeOfBirth: "Τόπος γέννησης", // translated
  groupLeader: "Αρχηγός ομάδας", // translated
  isRequired: "Απαιτείται", // translated
  charactersOnly: "Μόνο χαρακτήρες", // translated
  latinCharactersAndSpacesOnly: "Μόνο λατινικοί χαρακτήρες και κενά", // translated
  validEmail: "Δεν είναι έγκυρο email", // translated
  atLeastOneAdult: "Απαιτείται τουλάχιστον 1 ενήλικας.", // translated
  atLeastOneSenior: "Απαιτείται τουλάχιστον 1 ανώτερος.", // translated
  toastAlert: "Διορθώστε όλα τα σφάλματα στις παρακάτω φόρμες.", // translated
  backToFerriesList: "Επιστροφή στη λίστα πορθμείων", // translated
  bestPrice: "Καλύτερη τιμή", // translated
  fastest: "Ο πιο γρήγορος", // translated
  beforeDeparture: "Πριν την αναχώρηση", // translated
  perPerson: "ανά άτομο", // translated
  notAvailableForOnlineBooking: "Δεν διατίθεται για online κράτηση", // translated
  hurryLimitedAvailability: "Βιάσου! Περιορισμένη διαθεσιμότητα", // translated
  berth: "Κουκέτα", // translated
  berths: "Κλιμάκια", // translated
  sumOfSelectionNotEqualToPersons: "Το άθροισμα της επιλογής σας δεν είναι ίσο με τον αριθμό των επιβατών", // translated
  attemptToBook: "Προσπαθήσατε να κάνετε κράτηση συνολικά", // translated
  seatsWhenYouHave: "θέσεις όταν έχετε", // translated
  passengersTravelling: "επιβάτες που ταξιδεύουν", // translated
  withReturn: "με εισιτήρια μετ' επιστροφής", // translated
  pleaseCorrectYourSelection: "Διορθώστε την επιλογή σας", // translated
  pleaseSelectUpTo: "Επιλέξτε έως", // translated
  accommodationTypes: "τύπους καταλυμάτων", // translated
  selectionPrices: "Τιμές Επιλογής", // translated
  yourCurrentTicket: "Ο τρέχων τύπος εισιτηρίου σας είναι", // translated
  upgradeTo: "Αναβάθμιση σε", // translated
  wouldYouLikeToUpgrade: "Θα θέλατε να αναβαθμίσετε τον τύπο του εισιτηρίου σας;", // translated
  backToTicketTypes: "Επιστροφή στους τύπους εισιτηρίων", // translated
  originPort: "Λιμάνι προέλευσης", // translated
  destinationPort: "Λιμάνι προορισμού", // translated
  outboundDate: "Ημερομηνία εξόδου", // translated
  inboundDate: "Ημερομηνία εισόδου", // translated
  passengers: "Επιβάτες", // translated
  hasReturn: "Έχει Επιστροφή", // translated
  passportNumber: "Αριθμός διαβατηρίου", // translated
  passportExpiryDate: "ημερομηνία λήξης διαβατηρίου", // translated
  passportPlaceOfIssue: "Τόπος Έκδοσης Διαβατηρίου", // translated
  passportStartDate: "Ημερομηνία έναρξης διαβατηρίου", // translated
  cityCode: "Κωδικός Πόλης", // translated
};

export default ferries;
